module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-container"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "collections-header": _vm.collectionsHeader,
      "header": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides-container"
  }, [_c('div', {
    staticClass: "nav-top",
    class: {
      hidden: _vm.hidden_top
    },
    on: {
      "click": function($event) {
        _vm.slideUp()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-up-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "slides-data",
    style: ('margin-top:' + _vm.scrollPos + 'px;')
  }, _vm._l((_vm.figures), function(slide, index) {
    return _c('div', [_c('img', {
      class: {
        slide: true, active: _vm.selectedId === index
      },
      attrs: {
        "src": slide.optimized_urls.small,
        "target": slide.optimized_urls.hero
      },
      on: {
        "click": function($event) {
          _vm.selectThis(index, $event)
        },
        "load": function($event) {
          _vm.loadImg()
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom",
    class: {
      hidden: _vm.hidden_bottom
    },
    on: {
      "click": function($event) {
        _vm.slideDown()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-down-large"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52402c50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MediaContainerComponent.vue
// module id = 1432
// module chunks = 1